module.exports = __webpack_public_path__ + "static/media/online.9ed6a5b6.svg";